const getPageAfterBulkAction = (pagination: Pagination | undefined, isData: boolean) => {
  if (pagination === undefined) {
    return 1
  }
  if (isData) {
    return pagination.page
  }
  if (Number(pagination.page) > 1) {
    return Number(pagination.page) - 1
  }
  return 1
}

export {
  getPageAfterBulkAction
}
